module.exports = __webpack_public_path__ + "img/DK39608510.67206e4f.png";